import cx from 'classnames'
import { FC } from 'react'
import style from './arrowFlip.module.css'
import { Icon } from '@eventr/common-storybook'

type props = { open?: boolean; colour?: string }

export const ArrowFlip: FC<props> = ({
    open,
    colour = 'var(--primaryColor)',
}) => {
    return (
        <div className={cx(style.arrow, open && style.open)}>
            <Icon name={'Chevron_Up'} iconColour={colour} />
        </div>
    )
}
